// extracted by mini-css-extract-plugin
export var badge = "_v5-4";
export var selected = "_v5-1";
export var selectedOverlay = "_v5-5";
export var thumbnailButton = "_v5-0";
export var thumbnailFallback = "_v5-3";
export var thumbnailImage = "_v5-2";